var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topicPage"},[(_vm.datasList.length>0)?_c('div',_vm._l((_vm.datasList),function(item,index){return _c('div',{key:index},[_c('ActivityPage',{attrs:{"ItemDate":item,"access_token":_vm.access_token}})],1)}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-098560da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopicPage.vue
// module id = null
// module chunks = 